import {Button} from "slate-ui-components";
import styled from "styled-components";


export const NotificationMessage = styled.div`
	flex-shrink: 1;
	display: flex;
	align-items: center;
	flex-grow: 1;
`;

export const NotificationButtons = styled.div`
	display: flex;
	gap: 10px;
`;

export const NotificationCloseButton = styled(Button)`
	padding: 15px;
`;